export default "__VITE_ASSET__daca3e6b__"